//import axios from 'axios';
//import { useEffect, useReducer } from 'react';
import { systemCode, xs_languageCode, xs_sessionToken } from '..';
import { getAccountIds, getConfiguration } from './utils';
import $ from 'jquery';

function parseTickets(tickets) {
    return tickets.map(ticket => {
        return {
            id: ticket.id,
            type: ticket.ty,
            amount: ticket.amn,
            potentialWinnings: ticket.pwn,
            bonusAmount:ticket.bon,
            totalOdds: ticket.odd,
            betBuilderTotalOdd:ticket.bbo,
            isLive: ticket.liv,
            status: ticket.st,
            internalStatus: ticket.inSt,
            timestamp: ticket.tsp,
            eventsCount: ticket.nevs,
            funBonus: ticket.fnb,
            freeBet : ticket.frb,
            isCashoutable: ticket.csh,
            cashoutAmount : ticket.amnc,
            totalEventsNumber: ticket.nevs,
            openedEventsNumber: ticket.oes,
            paidWithCashout : ticket.pch,
            isBetBuilder : ticket.bb
        };
    });
}

function parseMyBetsData(data) {
    return {
        open: parseTickets(data.opns),
        ended: parseTickets(data.ends),
        live: parseTickets(data.livs),
        cashout: data.cshs? parseTickets(data.cshs) : []
    };
}

//export function useFetchMyBets(token) {
//    const [state, dispatch] = useReducer(dataFetchReducer, {
//        isLoading: true,
//        isError: false,
//    });
//    
//    useEffect(() => {
//        let didCancel = false;
//
//        const fetchData = async (url, params, callback) => {
//            dispatch({ type: 'FETCH_INIT' });
//            try {
//                const result = await axios.get(url, {params});
//                if (!didCancel) {
//                    callback(result.data);
//                }
//            } catch (error) {
//                console.error('Errore ' + url + ': ' + error);
//                if (!didCancel) {
//                    dispatch({ type: 'FETCH_FAILURE' });
//                }
//            }
//        };
//
//        const conf = getConfiguration();
//        const url = conf['api']['getMyBets'];
//        const params = {
//            systemCode,
//            lingua: xs_languageCode,
//            hash: '',
//            token: xs_sessionToken || token
//        };
//        fetchData(url, params, function(response) {
//            const data = parseMyBetsData(response);
//            dispatch({ type: 'FETCH_SUCCESS', payload: data });
//        });
//        return () => {
//            didCancel = true;
//        };
//    // eslint-disable-next-line react-hooks/exhaustive-deps
//    }, []);
//
//    return [state, dispatch];
//}

export function getMyBets(token, dateFrom, dateTo, successCallback, errorCallback){
  	const urlService = getConfiguration().api.getMyBets;
        let params = {
        systemCode,
        lingua: xs_languageCode,
        hash: '',
        token: xs_sessionToken || token,
        accountIds: getAccountIds()
	};

    if((dateFrom || null) !== null ) {
        params.dateFrom = dateFrom
    }

    if((dateTo || null) !== null ) {
        params.dateTo = dateTo
    }

	$.ajax({
		type: "POST",
		url : urlService,
		data: params,
		async : true,
		success : (data) => {
			if(data != null){
				const parsedData = parseMyBetsData(JSON.parse(data));
				successCallback(parsedData);
			}
		},
		error : (errorData) => {
			console.error(errorData);
		}	
   });
}
